import type { FormValues, FormValuesEvents } from "@/widgets/classic-form/form";
import { locationDataModelToScope } from "@/features/place-exactness";
import type { SearchDataModel } from "@/entities/data-model";
import { DATE_EXACTNESS_SCOPE } from "@/shared/constants/date-exactness";

// Year-proximity values that map to a real exactness option. Incoming dataModels aren't
// limited to these (other search UIs write proximities we don't offer, such as ±3, into
// their URLs); a year without a matching option must fall back to "Broad" — no selection.
const KNOWN_PROXIMITY_YEARS = new Set(Object.values(DATE_EXACTNESS_SCOPE).map(Number));

export const mapDataModelToFormValues = (dataModel: SearchDataModel): FormValues => {
    const mappedEvents: FormValuesEvents = {};

    Object.entries(dataModel.events).forEach(([eventKey, event]) => {
        mappedEvents[eventKey] = {
            instances: event.instances.map((instance) => ({
                ...instance,
                dateProximity: KNOWN_PROXIMITY_YEARS.has(instance.dateProximity.year as number)
                    ? instance.dateProximity
                    : { year: null, month: null, day: null },
                locationExactness: locationDataModelToScope(instance.locationExactness),
            })),
            relation: event.relation,
            eventName: event.eventName,
        };
    });

    return {
        ...dataModel,
        recordSubject: dataModel.filters.recordSubject,
        events: mappedEvents,
        timespan: {
            ...dataModel.timespan,
            isVisible: dataModel.timespan.yearStart != null && dataModel.timespan.yearEnd != null,
        },
    };
};
